import currenciesList from './currenciesList'
import SelectNew from './SelectNew'

const CurrencyPicker = ({
    value,
    onChange,
    disabled,
    error,
    placeholder = 'Currency',
    ...rest
}: {
    value: string
    onChange: (value: string | undefined) => void
    error?: string
    placeholder?: string
    disabled?: boolean
}) => {
    return (
        <SelectNew
            error={error}
            placeholder={placeholder}
            disabled={disabled}
            items={currenciesList}
            onChange={onChange}
            value={value}
            sx={{ width: 1 }}
            {...rest}
        />
    )
}

export default CurrencyPicker
